// extracted by mini-css-extract-plugin
export default {"container":"ErrorVerification_container__DcjIX","message":"ErrorVerification_message__zWeUK"};